/* eslint-disable */
export function resultTypeToAffix(resultType: string, mmsource: string): string {
	switch (resultType) {
		case "history":
			return "_h";
		case "destination":
			return "_d";
		case "search_w":
			return "_w";
		case "search_r":
			return "_r";
		case "search_m":
			return "_m";
		case "search_z":
			return "_z";
		default:
			return mmsource === "dim" ? "_f" : "";
	}
}
